import { en_countriesTranslation } from 'assets/locale/en/core/en_countriesTranslation';

const englishTranslation = {
  ...en_countriesTranslation,
  // HEADER //////////////////
  // Nav
  'header_nav_dashboard': 'Dashboard',
  'header_nav_dashboard_sales': 'Sales',
  'header_nav_dashboard_stock': 'Stock',
  'header_nav_dashboard_prediction': 'Prediction',
  'header_nav_catalog': 'Catalog',
  'header_nav_catalog-download': 'Download catalog',
  'header_nav_multimedia': 'Multimedia',
  'header_nav_clients': 'Clients',
  'header_sub-nav_view-catalog': 'View Catalog',
  'header_sub-nav_add-product': 'Add Product',
  'header_sub-nav_all-catalogs': 'Catalog Management',
  'header_update-catalog-references': 'Update references',
  'header_sub-nav_catalog-correlation': 'Reference correlation',
  'header_sub-nav_catalog-generic': 'Generic H4R',
  'header_sub-nav_catalog-tarifs': 'Rates',
  'header_sub-nav_multimedia-catalog': 'Multimedia Catalog',
  'header_sub-nav_multimedia-catalog-videos': 'Videos',
  'header_sub-nav_multimedia-catalog-images': 'Images',
  'header_sub-nav_multimedia-catalog-banners': 'Banners',
  'header_sub-nav_clients-list': 'Client List',
  'header_sub-nav_add-client': 'Add Client',
  'header_nav_sales': 'Sales',
  // Notifications
  'header_notifications_empty-notifications': 'There are no notifications',
  ////////////////////////////

  // SIGNUP PAGE /////////////
  'signup-page_title': 'Sign up in:',
  'signup-page_sub-title': 'Sign up to expand your business',
  'signup-page_button-brand': 'Sign up as a Brand',
  'signup-page_button-multibrand': 'Sign up as a Wholesale',
  'signup-page_button-brand-wh': 'Sign up as a brand or multibrand',
  'signup-page_return-to-login': 'Return to login',
  ////////////////////////////

  // ACCOUNT PAGE /////////////
  'profile-page_nav_profile': 'Profile',
  'profile-page_nav_company': 'Company Information',
  'profile-page_nav_main-contacts': 'Main Contacts',
  'profile-page_nav_commercial-info': 'Commercial Information',
  /////////////////////////////

  // DASHBOARDS //////////////
  'dashboard_empty-dashboard': 'Contact Hub4Retail to enable this service.',
  'dashboard_dashboard_error': 'Error loading the dashboard. If the problem persists, contact:',
  /////////////////////////////

  // HELMET ///////////////////
  'signup': 'Sign up',
  'home': 'Home',
  'dashboard': 'Dashboard',
  'multimedia': 'Multimedia',
  'multimedia-videos': 'Multimedia videos',
  'multimedia-images': 'Multimedia images',
  'multimedia-banners': 'Multimedia banners',
  'clients': 'Clients',
  'profile': 'Profile',
  'company': 'Company Information',
  'main-contacts': 'Main Contacts',
  'commercial-agents': 'Commercial agents',
  'catalog': 'Catalog',
  'notifications': 'Notifications',
  'commercial-profile': 'Commercial Profile',
  'all-catalogs': 'All Catalogs',
  'catalog-correlation': 'Reference Correlation',
  'catalog-generic': 'Generic H4R',
  'catalog_download': 'Download catalog',
  'catalog_update-references': 'Update references',
  'catalog_tarifs': 'Rates',
  // Client
  'client_resume': 'Summary',
  'client_business-info': 'Business Information',
  'client_contacts': 'Contacts',
  'client_brands-sold': 'Brands',
  'client_sale-points': 'Sale Points',
  'client_comercial-info': 'Commercial Information',
  'helmet_meta': 'Meta',
  'helmet_meta_edit_connection': 'Meta - Edit connection',
  'helmet_meta_edit_map': 'Meta - Edit map',
  /////////////////////////////

  // USERS ///////////////////////
  // Departments
  'users_department_commercial': 'Commercial',
  'users_department_administration': 'Administration',
  'users_department_agent': 'Agent',
  'users_department_owner': 'Owner',
  'users_department_store-manager': 'Store Manager',
  'users_department_logistics': 'Logistics',
  'users_department_marketing': 'Marketing',
  'users_department_others': 'Others',
  ////////////////////////////////

  // ACCOUNT //////////////////
  'account_profile_title': 'My Profile',
  'account-info-panel_title': 'General Information',
  'account-company-info-panel_title': 'Company Data',
  // Profile
  'account-info-panel_profile_name': 'Name',
  'account-info-panel_profile_lastname': 'Last Name',
  'account-info-panel_profile_email': 'Email',
  'account-info-panel_profile_phone-number': 'Phone Number',
  'account-info-panel_profile_department': 'Departament',
  'account-info-panel_profile_security-data': 'Security Data',
  'account-info-panel_profile_change-password': 'Change Password',
  'account-info-panel_profile_pwd_password-label': 'New Password',
  'account-info-panel_profile_pwd_repeat-password-label': 'Repeat the New Password',
  'account-info-panel_profile_pwd_change-button': 'Change Password',
  'account-info-panel_profile_pwd_validation': 'The password must be at least 8 characters and a maximum of 16, 1 number, 1 uppercase letter, and one lowercase letter.',
  'account-info-panel_profile_pwd_validation-match': 'The passwords do not match',
  'account-info-panel_profile_pwd_change-success': 'Password changed successfully.',
  'account-info-panel_profile_pwd_empty-inputs': 'Fill in the empty fields.',
  // Profile form
  'account-profile_form-input_name': 'Enter your name',
  'account-profile_form-input_name-validation': 'Please enter your name',
  'account-profile_form-input_lastname': 'Enter your last name',
  'account-profile_form-input_lastname-validation': 'Please enter your last name',
  'account-profile_form-input_email': 'Enter your email',
  'account-profile_form-input_email-validation-required': 'Please enter your email',
  'account-profile_form-input_email-validation': 'The email is not valid',
  'account-profile_form-input_department': 'Enter the departament',
  'account-profile_form-input_department-validation': 'Please enter the departament',
  'account-profile_form-input_phone-number': '',
  'account-profile_form-input_phone-number-validation': 'Please enter the phone number',
  // Company
  'account-info-panel_company_title': 'Company Data',
  'account-info-panel_company_cif': 'VAT (Tax Identification)',
  'account-info-panel_company_trade-name': 'Brand Name',
  'account-info-panel_company_business-name': 'Company Name',
  'account-info-panel_company_address': 'Address',
  'account-info-panel_company_postal-code': 'Postal Code',
  'account-info-panel_company_population': 'City',
  'account-info-panel_company_country': 'Country',
  'account-info-panel_company_email': 'Email',
  'account-info-panel_company_phone-number': 'Phone Number',
  'account-info-panel_company_contact_name': 'Main Contact',
  'account-info-panel_company_metas-connected_title': 'Connected Goals',
  'account-info-panel_company_active-seasons_title': 'Active Seasons',
  // Company form
  'account-company_form-input_trade-name': 'Enter the Brand Name',
  'account-company_form-input_trade-name-validation': 'Please enter the brand name',
  'account-company_form-input_business-name': 'Enter the Company Name',
  'account-company_form-input_business-name-validation': 'Please enter the Company Name',
  'account-company_form-input_country': 'Enter the country',
  'account-company_form-input_country-validation': 'Please enter the country',
  'account-company_form-input_population': 'Enter the city',
  'account-company_form-input_population-validation': 'Please enter the city',
  'account-company_form-input_address': 'Enter the address',
  'account-company_form-input_address-validation': 'Please enter your address',
  'account-company_form-input_postal-code': 'Enter the postal code',
  'account-company_form-input_postal-code-validation': 'Please enter the postal code',
  'account-company_form-input_cif': 'Enter the VAT (Tax Identification)',
  'account-company_form-input_cif-validation': 'Please enter the VAT (Tax Identification)',
  'account-company_form-input_phone-number': 'Phone Number',
  'account-company_form-input_phone-number-validation': 'Please enter the phone number',
  'account-company_form-input_email': 'Enter the company email',
  'account-company_form-input_contact_name_en': 'Enter the main contact of the company',
  'account-company_form-input_contact_name-validation-required_en': 'Please enter the main contact of the company',
  'account-company_form-input_email-validation-required': 'Please enter your email',
  'account-company_form-input_email-validation': 'The email is not valid',
  'account-company_form-input_instagram': 'Enter the Instagram URL',
  'account-company_form-input_youtube': 'Enter the Youtube URL',
  'account-company_form-input_linkedin': 'Enter the Linkedin URL',
  'account-company_form-input_facebook': 'Enter the Facebook URL',
  'account-company_social-media-title': 'Social Media',
  'account-company_form-input_social-media-label': 'Social Network Name',
  'account-company_form-input_social-media-label-placeholder': 'Name of the Social Network',
  'account-company_form-input_social-media-label_validation': 'Please, enter the name of the social network',
  'account-company_form-input_social-media-value': 'Social Network URL',
  'account-company_form-input_social-media-value-placeholder': 'URL of the Social Network',
  'account-company_form-input_social-media-value_validation': 'Please, enter the URL of the social network',
  'account-company_form-input_social-media-add-button': 'Add Social Network',
  'account-company_form-input_social-media-accept-button_title': 'Update Social Network',
  'account-company_form-input_social-media-reject-button_title': 'Discard Changes',
  'account-company_form-input_social-media-delete-button_title': 'Delete Social Network',
  'account-company_form-input_social-media-delete-button_popconfirm_title': 'Delete Social Network',
  'account-company_form-input_social-media-delete-button_popconfirm_description': 'Are you sure you want to delete this Social Network?',
  'account-company_form-input_social-media-delete-button_popconfirm_ok': 'Delete',
  'account-company_form-input_social-media-delete-button_popconfirm_cancel': 'Cancel',
  // Main Contacts
  'main-contacts_title': 'Main Contacts',
  'main-contacts_add-contact': '+ Add',
  'main-contacts_table_name': 'Name',
  'main-contacts_table_lastname': 'Last Name',
  'main-contacts_table_email': 'Email',
  'main-contacts_table_phone-number': 'Phone Number',
  'main-contacts_table_department': 'Department',
  'main-contacts_table_pop-confirm_title': 'Delete contact',
  'main-contacts_table_pop-confirm_description': 'Are you sure you want to delete this contact?',
  'main-contacts_table_pop-confirm_btn-accept': 'Delete',
  'main-contacts_table_pop-confirm_btn-cancel': 'Cancel',
  // Main Contacts Form
  'main-contacts_form-label_name': 'Name',
  'main-contacts_form-label_lastname': 'Last Name',
  'main-contacts_form-label_email': 'Email',
  'main-contacts_form-label_phone-number': 'Phone Number',
  'main-contacts_form-label_department': 'Department',
  'main-contacts_form-input_name': 'Enter the name',
  'main-contacts_form-input_lastname': 'Enter the last name',
  'main-contacts_form-input_email': 'Enter the email',
  'main-contacts_form-input_department': 'Enter the department',
  'main-contacts_form_sector_label': 'Sector',
  'main-contacts_form-input_sector': 'Enter the sector',
  'main-contacts_form-input_sector_validation': 'Enter the sector',
  'main-contacts_form-input_phone-number': 'Enter the phone number',
  'main-contacts_form-input-validation_name': 'Please enter the name',
  'main-contacts_form-input-validation_lastname': 'Please enter the last name',
  'main-contacts_form-input-validation_email': 'The email is not valid',
  'main-contacts_form-input-validation-required_email': 'Please enter the email',
  'main-contacts_form-input-validation_department': 'Please enter the department',
  // Comercial agents
  'commercial-agents_add-contact': '+ Add agent',
  'commercial-agents_table_agent-name': 'Commercial agent',
  'commercial-agents_table_buy-group': 'Buying group',
  'commercial-agents_table_clients': 'Clients',
  'commercial-agents_table_clients-placeholder': 'Select clients',
  'commercial-agents_table_telephone': 'Phone',
  'commercial-agents_table_pop-confirm_title': 'Delete commercial agent',
  'commercial-agents_table_pop-confirm_description': 'Are you sure you want to delete this commercial agent?',
  'commercial-agents_table_pop-confirm_btn-accept': 'Delete',
  'commercial-agents_table_pop-confirm_btn-cancel': 'Cancel',
  'commercial-agents_drawer_title': 'Commercial Information',
  // Comercial agents form
  'commercial-agents_form-fiscal-google-form-title': 'Fiscal address',
  'commercial-agents_form-commercial-google-form-title': 'Commercial address',
  'commercial-agents_form-label_name': 'Name',
  'commercial-agents_form-label_lastname': 'Last name',
  'commercial-agents_form-label_trade-name': 'Company',
  'commercial-agents_form-label_cif': 'CIF | NIF | DNI',
  'commercial-agents_form-label_phone-number': 'Phone',
  'commercial-agents_form-input_name': 'Enter name',
  'commercial-agents_form-label_email': 'Email',
  'commercial-agents_form-label_sector': 'Sector',
  'commercial-agents_form-input_email': 'Enter email',
  'commercial-agents_form-input_sector': 'Enter sector',
  'commercial-agents_form-input_yes': 'Yes',
  'commercial-agents_form-input_no': 'No',
  'commercial-agents_form-input_lastname': 'Enter last name',
  'commercial-agents_form-input_trade-name': 'Enter company name',
  'commercial-agents_form-input_cif': 'Enter CIF, NIF or DNI',
  'commercial-agents_form-input_phone-number': 'Enter phone',
  'commercial-agents_form-input_web': 'Enter website',
  'commercial-agents_form-input-validation_name': 'Please enter name',
  'commercial-agents_form-input-validation_email': 'Please enter email',
  'commercial-agents_form-input-validation_sector': 'Please enter sector',
  'commercial-agents_form-input-validation_buy-group': 'Please enter buying group',
  'commercial-agents_form-input-validation_lastname': 'Please enter last name',
  'commercial-agents_form-input-validation_trade-name': 'Please enter company name',
  'commercial-agents_form-input-validation_cif': 'Please enter CIF, NIF or DNI',
  'commercial-agents_form-input-validation_phone-number': 'Please enter phone',
  // Shared
  'notification-form-item_label': 'Notification settings',
  // Drawers
  'account-profile_drawer_title': 'General Information',
  'account-company_drawer_title': 'Company Data',
  'main-contacts_drawer_title': 'Main Contacts',
  'main-contacts_drawer_create-title': 'Create contact',
  'main-contacts_drawer_update-title': 'Update contact',
  /////////////////////////////

  // MULTIMEDIA ///////////////
  'multimedia_nav-videos': 'Videos',
  'multimedia_nav-images': 'Images',
  'multimedia_sort-btn': 'Sort by',
  'multimedia_filter-btn': 'Filters',
  'multimedia_apply-filters-btn': 'Apply filters',
  'multimedia_search-input-placeholder': 'Search by brand, season, country, date',
  'multimedia_search-results': 'Results',
  'multimedia_sort-last-favorites': 'Favorites',
  'multimedia_download': 'Download',
  'multimedia_download_started': 'The download has started',
  'multimedia_open': 'Open',
  'multimedia_link-copied': 'Link copied to clipboard',
  'multimedia_link-copy-button': 'Copy link',
  'multimedia_delete-popconfirm-title': 'Delete multimedia',
  'multimedia_delete-popconfirm-description': 'Are you sure you want to delete this file?',
  // Sort by
  'multimedia_sort-last-aggregates': 'Last added',
  'multimedia_sort-best-seller': 'Best seller',
  'multimedia_sort-less-sold': 'Least sold',
  'multimedia_sort-best-pvp_great-minor': 'Price: high to low',
  'multimedia_sort-best-pvp_minor-great': 'Price: low to high',
  'multimedia_sort-best-pvi_great-minor': 'PVI: high to low',
  'multimedia_sort-best-pvi_minor-great': 'PVI: low to high',
  'multimedia_sort-by-color': 'By color A-Z',
  'multimedia_sort-by-reference': 'By reference A-Z',
  // Images
  'multimedia_images_popover-edit': 'Edit',
  'multimedia_images_popover-remove': 'Delete',
  'multimedia_images_popover-yes': 'Yes',
  'multimedia_images_popover-no': 'No',
  // Filter
  'multimedia_filter-remove-filters': 'Delete Filters',
  'multimedia_filter-season': 'Season',
  'multimedia_filter-division': 'Division',
  'multimedia_filter-genders': 'Gender',
  'multimedia_filter-visualization': 'Visualization',
  'multimedia_filter-image-rights': 'Image rights',
  'multimedia_filter-country': 'Country',
  'multimedia_filter-tags': 'Tags',
  'multimedia_filter-favorites': 'Favorites',
  'multimedia_filter-start': 'Playable from',
  'multimedia_filter-end': 'Playable until',
  //Dragger
  'multimedia_upload-images-manually_dragger_msg-error': 'Supported files',
  'multimedia_upload-images-manually_dragger_msg_image-size-limit_error': 'The image size must be under 3MB',
  'multimedia_upload-images-manually_dragger_msg_video-size-limit_error': 'The video size must be under 100MB',
  'multimedia_upload-images-manually_dragger_text-1': 'Click or drag and drop an image',
  // Upload image manually
  'multimedia_upload-images-manually_form-item_selection': 'Select',
  'multimedia_upload-images-manually_form-item_title': 'Title',
  'multimedia_upload-images-manually_form-item_title-required': 'Please enter the image title',
  'multimedia_upload-images-manually_form-item_usage-required': 'Please enter the usage type',
  'multimedia_upload-images-manually_form-item_name': 'Technical Name',
  'multimedia_upload-images-manually_form-item_name-required': 'Please enter the image name',
  'multimedia_upload-images-manually_form-item_description': 'Description',
  'multimedia_upload-images-manually_form-item_description-required': 'Please, enter the description',
  'multimedia_upload-images-manually_form-item_divisions': 'Division',
  'multimedia_upload-images-manually_form-item_season': 'Season',
  'multimedia_upload-images-manually_form-item_language': 'Language',
  'multimedia_upload-images-manually_form-item_genders': 'Gender',
  'multimedia_upload-images-manually_form-item_products': 'Products',
  'multimedia_upload-images-manually_form-item_catalog_id': 'Id catalogue',
  'multimedia_upload-images-manually_form-item_catalog_id_text-1': 'Field associated with Chronos to define its advertising circuit',
  'multimedia_upload-images-manually_form-item_catalog_id_text-2': 'Contact Hub4Retail to activate Chronos',
  'multimedia_upload-images-manually_form-item_usage': 'Use of content',
  'multimedia_upload-images-manually_form-item_visualization': 'Visualization',
  'multimedia_upload-images-manually_form-item_tags': 'Tags',
  'multimedia_upload-images-manually_form-item_tags_text-1': 'Create your own tags',
  'multimedia_upload-images-manually_form-item_start': 'Playable from',
  'multimedia_upload-images-manually_form-item_end': 'Playable until',
  'multimedia_upload-images-manually_form-item_copyright': 'Does this video have image rights?',
  'multimedia_upload-images-manually_form-item_enable_download': 'Do you allow downloading?',
  'multimedia_upload-images-manually_form-item_countries': 'Country',
  'multimedia_upload-images-manually_form-item_add': 'Add',
  'multimedia_upload-images-manually_form-item_next': 'Next',
  'multimedia_upload-images-manually_form-item_yes': 'Yes',
  'multimedia_upload-images-manually_form-item_no': 'No',
  // Modal manually
  'multimedia_upload-images-manually_modal_title': 'Update image',
  'multimedia_upload-images-manually_modal_step-1': 'Select an image',
  'multimedia_upload-images-manually_modal_step-2': 'Complete the data',
  'multimedia_upload-images-manually_modal_step-2-msg': 'Image title',
  'multimedia_upload-images-manually_modal_step-3-msg': 'Multimedia uploaded successfully',
  // Upload images CSV
  'multimedia_upload-images_button': 'Upload images',
  'multimedia_upload-images_step-1': 'Select images',
  'multimedia_upload-images_step-1_dragger_text-1': 'Click or drag and drop image files',
  'multimedia_upload-images_step-1_dragger_text-2': 'Take note of the following...',
  'multimedia_upload-images_step-1_dragger_text-3': 'Save the images with the name',
  'multimedia_upload-images_step-1_dragger_text-4': 'reference_color_imagen#',
  'multimedia_upload-images_step-2': 'Upload CSV',
  'multimedia_upload-images_step-2_dragger_text-1': 'Click or drag and drop the CSV file',
  'multimedia_upload-images_step-3': 'Upload finished!',
  'multimedia_upload-images_step-3-text': 'image files uploaded',
  'multimedia_upload-images_modal_title': 'Upload images',
  'multimedia_upload-images_modal_btn-back': 'Back',
  'multimedia_upload-images_modal_btn-next': 'Next',
  'multimedia_upload-images_modal_btn-close': 'Close',
  //Upload
  'multimedia_upload_step-2': 'Complete the details',
  // Upload videos
  'multimedia_upload-videos_button': 'Upload video',
  'multimedia_upload-videos_step-1_dragger_text-1': 'Click or drag and drop video files',
  'multimedia_upload-videos_step-1': 'Select video',
  'multimedia_upload-videos_modal_title': 'Upload video',
  // Upload banners
  'multimedia_upload-banners_button': 'Upload banners',
  'multimedia_upload-banners_modal_title': 'Upload banner',
  'multimedia_upload-banner_step-1': 'Select banner',
  'multimedia_upload-banners_step-1_dragger_text-1': 'Click or drag and drop a banner',
  ////////////////////////////

  // BRAND USERS /////////////////
  'brand-user_title': 'Users',
  'brand-user_description': 'Control how members of your team interact with Hub4Retail.',
  'brand-user_create-user': 'Add user',
  'brand-user_modal_title-create': 'Add user',
  'brand-user_modal_title-edit': 'Edit user',
  'brand-user_modal_input_name': 'Name',
  'brand-user_modal_input_lastname': 'Last name',
  'brand-user_modal_input_email': 'Email',
  'brand-user_modal_input_password': 'Password',
  'brand-user_modal_input_btn-save': 'Save',
  'brand-user_modal_input_btn-cancel': 'Cancel',
  'brand-user_table_name': 'Name',
  'brand-user_table_email': 'Email',
  'brand-user_table_role': 'Role',
  'brand-user_table_last-session': 'Last session',
  'brand-user_table_last-session-never': 'Never',
  'brand-user_delete-popconfirm_title': 'Delete the user',
  'brand-user_delete-popconfirm_description': 'Are you sure you want to delete this user?',
  'brand-user_delete-popconfirm_confirm': 'Yes',
  'brand-user_delete-popconfirm_cancel': 'No',
  'brand-user_delete-popconfirm_icon-tooltip': 'Delete connection',
  ////////////////////////////////

  // CATALOG //////////////////
  'catalog_add-product': 'Add product',
  'catalog_ProductList_results': 'Results',
  'catalog_no-more-results': 'No results found...',
  'catalog_tags_delete-all': 'Delete all',
  'catalog_loading-filters': 'Loading filters',
  // Sort by
  'catalog_search-input-placeholder': 'Search by reference',
  // Sor by images
  'catalog_sort-by-images_with-images': 'With images',
  'catalog_sort-by-images_without-images': 'Without images',
  'catalog_sort-by-images_all': 'All products',
  'catalog_sort-by-images_download-csv-products-without-images-tooltip': 'Download CSV of products without images',
  // Add catalog
  'catalog_add-catalog-csv-input-title': 'Upload CSV of products',
  'catalog_add-catalog-csv-s1-text-1': 'Option',
  'catalog_add-catalog-csv-s1-text-2': 'You can download our',
  'catalog_add-catalog-csv-s1-text-3': 'excel template',
  'catalog_add-catalog-csv-s1-text-4': 'or',
  'catalog_add-catalog-csv-s1-text-5': 'Upload your own template',
  'catalog_add-catalog-csv-s2-text-1': 'Upload CSV',
  'catalog_add-catalog-csv-s2-text-2': 'Upload images',
  'catalog_add-catalog-csv-s2-text-3': 'Determine start and end dates of the seasons',
  'catalog_add-catalog-csv_dowload-template-success': 'Template downloaded successfully',
  // Correlation-Generic
  'catalog-correlation_select-all': 'All references',
  'catalog-correlation_select-no-associated': 'Unique references by generic H4R',
  'catalog-correlation_select-no-associated-at-all': 'Unassigned references',
  'catalog-correlation_select-all_tooltip': 'View all available references',
  'catalog-correlation_select-no-associated_tooltip': 'View references that are not repeated in more than one generic H4R',
  'catalog-correlation_select-no-associated-at-all_tooltip': 'View references that are not assigned to any generic H4R',
  'catalog-correlation_empty-values': 'No values have been selected to assign',
  'catalog-correlation_not-associated': 'Unassigned',
  'catalog-correlation_season-label': 'Season',
  'catalog-correlation_gender-label': 'Gender',
  'catalog-correlation_color-label': 'Color',
  'catalog-correlation_color-code-label': 'Color code',
  'catalog-correlation_segmentation-label': 'Segmentation',
  'catalog-correlation_division-label': 'Division',
  'catalog-correlation_family-label': 'Family',
  'catalog-correlation_table_column_h4r': 'Generic H4R',
  'catalog-correlation_unused-references': 'Unassigned references',
  'catalog-correlation_table_accept-btn': 'Save',
  'catalog-correlation_table_reject-btn': 'Cancel',
  'catalog-correlation_table_required-field': 'Required field',
  'catalog-correlation_table_add-field': 'Add',
  'catalog-correlation_pending-correlations': 'not assigned',
  'catalog-correlation_pendings-correlations': 'not assigned',
  // Upload product images
  'catalog_handle-images_pattern_title': 'Image pattern',
  'catalog_handle-images_pattern_description': 'Select the image name pattern:',
  'catalog_handle-images_pattern_separator': 'Separator:',
  'catalog_handle-images_pattern_label': 'Pattern:',
  'catalog_handle-images_pattern_save': 'Save pattern',
  'catalog_handle-images_pattern_create-message-success': 'Pattern saved successfully',
  'catalog_handle-images_pattern_create-message-error': 'Error saving pattern',
  'catalog_handle-images_upload_title': 'Upload images',
  'catalog_handle-images_upload_upload-image-success': 'Image saved',
  'catalog_handle-images_upload_upload-images-success': 'Images saved',
  'catalog_handle-images_upload_upload-image-without-pattern-success': 'Image without pattern saved',
  'catalog_handle-images_upload_upload-images-without-pattern-success': 'Images without pattern saved',
  'catalog_handle-images_upload_upload-images-success-correctly': 'correctly',
  'catalog_handle-images_upload_upload-image-error': 'Error uploading images',
  'catalog_handle-images_upload_upload-image-btn': 'Upload images',
  'catalog_handle-images_upload_selected-images': 'Selected images:',
  'catalog_handle-images_upload_previously-uploaded-images': 'Previously uploaded images:',
  'catalog_handle-images_upload_uploaded-images': 'Uploaded images:',
  'catalog_handle-images_upload_images-without-pattern': 'Images without pattern:',
  'catalog_handle-images_upload_save-images-confirm': 'Do you want to save the images without pattern?',
  'catalog_handle-images_not-matched-images_title': 'Images not matching any product',
  'catalog_handle-images_not-matched-images_save-success': 'Images assigned successfully',
  'catalog_handle-images_not-matched-images_save-error': 'Error assigning images',
  'catalog_handle-images_not-matched-images_search-placeholder': 'Search images by reference',
  'catalog_handle-images_not-matched-images_search-clear-btn': 'Clear search',
  'catalog_handle-images_not-matched-images_assign-product-btn': 'Assign to product',
  'catalog_handle-images_not-matched-images_cancel-product-selection': 'Cancel selection',
  // Catalog download
  'catalog_download_alert_brand-required': 'Please select a brand',
  'catalog_download_alert_get-filters-error': 'Error fetching filters',
  'catalog_download_alert_dowloading-compressed-files': 'Downloading compressed files...',
  'catalog_download_progress-images': 'Images',
  'catalog_download_success-msg': 'Images downloaded successfully',
  'catalog_download_success-msg-imgs-and-csv': 'CSV and images downloaded successfully',
  'catalog_download_csv-msg-without-images': 'CSV downloaded successfully',
  'catalog_download_csv-msg-pending-images': 'CSV downloaded successfully, but images are pending',
  'catalog_download_csv-msg-pending-images-navigate': 'CSV downloaded successfully, but images are pending. You can continue browsing while downloading',
  'catalog_download_apply-changes-btn': 'Apply changes',
  'catalog_download_cancel-filter-btn': 'Cancel',
  'catalog_download_cancel-values-selection-btn': 'Clear selection',
  'catalog_download_cancel-values-download-btn': 'Cancel download',
  'catalog_download_clear-filters-btn': 'Clear filters',
  'catalog_download_result': 'result',
  'catalog_download_results': 'results',
  'catalog_download_select-column': 'Select column',
  'catalog_download_input-seasons': 'Enter seasons',
  'catalog_download_input-value': 'Enter value',
  'catalog_download_update': 'Update',
  'catalog_download_columns_search-on': 'Search in',
  'catalog_download_columns_operator_contains': 'Contains',
  'catalog_download_columns_operator_ends-with': 'Ends with',
  'catalog_download_columns_operator_starts-with': 'Starts with',
  'catalog_download_columns_operator_equals': 'Equals',
  'catalog_download_columns_operator_not-equals': 'Not equals',
  'catalog_download_columns_operator_in': 'In',
  'catalog_download_columns_operator_not-in': 'Not in',
  'catalog_download_columns_operator_greater-than': 'Greater than',
  'catalog_download_columns_operator_less-than': 'Less than',
  'catalog_download_columns_operator_is-null': 'Is null',
  'catalog_download_columns_operator_is-not-null': 'Is not null',
  'catalog_download_columns_all-images': 'All products',
  'catalog_download_columns_with-images': 'With images',
  'catalog_download_columns_without-images': 'Without images',
  'catalog_download_columns_favorites': 'Favorites',
  'catalog_download_columns_not-downloaded': 'Not downloaded',
  'catalog_download_columns_column-search_search': 'Search',
  'catalog_download_columns_column-search_reset': 'Reset',
  'catalog_download_columns_column-search_close': 'Close',
  'catalog_download_list_select-all': 'Select all',
  'catalog_download_list_clear-all': 'Clear selection',
  'catalog_download_list_download-btn': 'Download',
  'catalog_download_list_download-images-btn': 'Download images',
  'catalog_download_list_item': 'item',
  'catalog_download_list_items': 'items',
  'catalog_download_list_select-order_popover-title': 'Select and sort',
  ///////////////////////////

  // TABLES ///////////////////////////////////////
  'table_columns_brand': 'Brand',
  'table_columns_reference': 'Reference',
  'table_columns_ean': 'Brand EAN',
  'table_columns_size': 'Size',
  'table_columns_name': 'Name',
  'table_columns_color': 'Color description',
  'table_columns_color_code': 'Color code',
  'table_columns_pvi': 'PVI',
  'table_columns_pvpr': 'PVPR',
  'table_columns_division': 'Division',
  'table_columns_gender': 'Gender',
  'table_columns_season': 'Season',
  'table_columns_segmentation': 'Segmentation',
  'table_columns_family': 'Family',
  'table_columns_material': 'Composition',
  'table_columns_images': 'Images',
  'table_columns_product_description': 'Product description',
  'table_columns_client_ean': 'Multibrand EAN',
  'table_columns_count': 'Repetitions',
  'table_columns_size_uk': 'Size UK',
  'table_columns_size_us': 'Size US',
  'table_columns_brand_name': 'Brand name',
  /////////////////////////////////////////////////

  // PRODUCT PAGE ///////////
  'product_infoBox_codeEAN': 'EAN code',
  'product_collection_title': 'All collection',
  'product_infoProduct_other_colors': 'Other colors',
  'product_infoProduct_currency': '€',
  'product_infoProduct_sizes': 'Sizes and prices',
  'product_infoProduct_EAN_size': 'Sizes',
  'product_infoProduct_EAN_code': 'EAN codes',
  'product_collapse_title_key1': 'Sizes',
  'product_collapse_title_key2': 'GENERAL INFORMATION',
  'product_collapse_title_key3': 'COMPOSITION',
  'product_card-color': 'color',
  'product_mobile_product-details_sizes': 'Sizes and prices',
  'product_mobile_product-details_size': 'Size',
  'product_mobile_product-details_info': 'General Information',
  'product_mobile_product-details_ean-codes': 'EAN Codes',
  'product_mobile_product-details_ean-code': 'EAN Code',
  'product_mobile_product-details_composition': 'Composition',
  'product_related-videos_title': 'Multimedia Catalog',
  'product_related-videos_subtitle': 'Related Videos',
  'product_related-products_title': 'You might also be interested in...',
  'product_card_sold-units': 'Sold units:',
  'product_card_ranking': 'Ranking:',
  // Edit product
  'product_edit-product_button': 'Edit product',
  'product_edit-product_modal_title': 'Edit',
  'product_edit-product_modal_season': 'Season',
  'product_edit-product_modal_season_required': 'Please enter the season',
  'product_edit-product_modal_product-description': 'Product description',
  'product_edit-product_modal_product-description_required': 'Please enter the description',
  'product_edit-product_modal_color-name': 'Color name',
  'product_edit-product_modal_color-name_required': 'Please enter the color name',
  'product_edit-product_modal_color-code': 'Color code',
  'product_edit-product_modal_color-code_required': 'Please enter the color code',
  'product_edit-product_modal_gender': 'Gender',
  'product_edit-product_modal_gender_required': 'Please enter the gender',
  'product_edit-product_modal_family': 'Family',
  'product_edit-product_modal_family_required': 'Please enter the family',
  'product_edit-product_modal_division': 'Division',
  'product_edit-product_modal_division_required': 'Please enter the division',
  'product_edit-product_modal_segmentation': 'Segmentation',
  'product_edit-product_modal_segmentation_required': 'Please enter the segmentation',
  'product_edit-product_modal_material': 'Material',
  'product_edit-product_modal_material_required': 'Please enter the material composition',
  'product_edit-product_modal_cancel-button': 'Cancel',
  'product_edit-product_modal_save-button': 'Save',
  ///////////////////////////

  // THANKS PAGE ////////////
  'ThanksForRegister__register': 'BRANDS REGISTRATION',
  'ThanksForRegister__title': 'Thank you for your interest in Hub4Retail!',
  'ThanksForRegister__subtitle': 'Your request is being processed and we will get back to you shortly.',
  'ThanksForRegister__button': 'Go to the website',
  ///////////////////////////

  // REGISTER BRAND /////////
  'RegisterBrand__title1': 'Ready to start',
  'RegisterBrand__title2': 'taking your business to the',
  'RegisterBrand__title3': 'next level?',
  'RegisterBrand__subtitle': 'Platform designed to:',
  'RegisterBrand__ex1': 'Enhance collaboration and sharing tools.',
  'RegisterBrand__ex2': 'Ensure data security at all times.',
  'RegisterBrand__ex3': 'Increase profit margins.',
  'RegisterBrand__button': 'Back',
  'RegisterBrand__register': 'Registration',
  'registerBrand__form__name': 'Name',
  'registerBrand__form__lastName': 'Last Name',
  'registerBrand__form__business': 'Business Name',
  'registerBrand__form__company': 'Trade Name',
  'registerBrand__form__phone': 'Web',
  'registerBrand__form__email': 'Phone',
  'registerBrand__form__web': 'Corporate Email',
  'registerBrand__form__description': 'Would you like to tell us something more?',
  'registerBrand__form__selector': 'Sector',
  'registerBrand__form__say-more': 'Would you like to tell us something more?',
  'registerBrand__form__selector__optionDefault': '',
  'registerBrand__form__selector__option1': 'Footwear',
  'registerBrand__form__selector__option2': 'Accessories',
  'registerBrand__form__selector__option3': 'Home-Garden',
  'registerBrand__form__selector__option4': 'Beauty',
  'registerBrand__form__selector__option5': 'Electronics',
  'registerBrand__form__selector__option6': 'Sports',
  'registerBrand__form__selector__option7': 'Automotive',
  'registerBrand__form__selector__option8': 'Food',
  'registerBrand__form__selector__option9': 'Other',
  //////////////////////////

  // CLIENTS ///////////////
  'clients_by-client-btn': 'By client',
  'clients_by-points-sale-btn': 'Per store',
  'clients_add-client-link': '+ Add client',
  'clients_add-search-input': 'Search...',
  'clients_filters-btn': 'Filters',
  // Tables
  'clients_clients-table_businessName': 'Company Name',
  'clients_clients-table_tradeName': 'Brand Name',
  'clients_clients-table_clientCode': 'Client Code',
  'clients_clients-table_tarif-code': 'Rate code',
  'clients_clients-table_city': 'City',
  'clients_clients-table_totalPointsSale': 'Total Stores',
  'clients_clients-table_totalPointsSale_popover-title': 'There are points of sale with new data',
  'clients_clients-table_totalPointsSale_popover-btn': 'Go to points of sale',
  'clients_clients-table_totalPointsSale_client-popover-title': 'has updated data',
  'clients_clients-table_totalPointsSale_client-popover-content': 'data added or updated',
  'clients_clients-table_totalPointsSale_client-popover-content-2': 'data added or updated',
  'clients_clients-table_totalPointsSale_client-popover-btn': 'Go to the client',
  'clients_client-table_status': 'Status',
  'clients_client-table_action_see-profile': 'View profile',
  'clients_client-table_action_remove-popconfirm_title': 'Reject association',
  'clients_client-table_action_remove-popconfirm_description': 'Are you sure you want to reject this association?',
  'clients_client-table_action_remove-popconfirm_on-ok': 'Accept',
  'clients_client-table_action_remove-popconfirm_on-cancel': 'Cancel',
  'clients_client-table_action_reject-popconfirm_title_en': 'Unlink Association',
  'clients_client-table_action_reject-popconfirm_description_en': 'Are you sure you want to unlink this association?',
  'clients_client-table_action_reject-popconfirm_on-ok_en': 'Accept',
  'clients_client-table_action_reject-popconfirm_on-cancel_en': 'Cancel',
  'clients_client-table_action_delete-popconfirm_title': 'Delete point of sale',
  'clients_client-table_action_delete-popconfirm_description': 'Are you sure you want to delete this point of sale?',
  'clients_client-table_action_delete-popconfirm_icon-tooltip': 'Delete point of sale',
  'clients_client-table_action_dissasociate-popconfirm_on-ok': 'Disassociate',
  'client_clients-page_table_disassociate-modal_title_en': 'Unlink Client',
  'client_clients-page_table_disassociate-modal_on-ok_en': 'Unlink',
  'client_clients-page_table_disassociate-modal_on-cancel_en': 'Cancel',
  'client_clients-page_table_disassociate-modal_content_en': 'Are you sure you want to unlink this client and all its sales points?',
  'clients_sale-point-table_businessName': 'Company Name',
  'clients_sale-point-table_shop-name': 'Store Name',
  'clients_sale-point-table_category': 'Category',
  'clients_sale-point-table_tradeName': 'Brand Name',
  'clients_sale-point-table_pointSaleCode': 'Store Code',
  'clients_sale-point-table_city': 'City',
  'clients_sale-point-table_personae-and-tier': 'Personae & Tier',
  'clients_sale-point-table_share-data': 'Share data',
  'clients_sale-point-table_share-data-popover-share': 'Receiving client sales data.',
  'clients_sale-point-table_share-data-popover-no-share': 'Not receiving client sales data.',
  'clients_sale-point-table_recive-data': 'Receive data',
  'clients_sale-point-table_recive-data_green_en': 'Receiving client sales data.',
  'clients_sale-point-table_recive-data_orange_en': 'The client is not sharing data.',
  'clients_sale-point-table_recive-data_red_en': 'No data is being received from the goal.',
  'clients_sale-point-table_connection': 'Connection',
  'clients_sale-point-table_connection-popover-share': "Connected to client's stores terminal.",
  'clients_sale-point-table_connection-popover-no-share': "Not connected to client's stores terminal.",
  'clients_sale-point-table_active': 'Active',
  'clients_sale-point-table_inactive': 'Inactive',
  'clients_sale-point-table_connected': 'Connected',
  'clients_sale-point-table_not-connected': 'Not connected',
  'clients_sale-point-table_total-clients': 'Total clients',
  'clients_sale-point-table_total-sale-points': 'Total stores',
  // Association
  'clients_association-modal_title': 'Associate client',
  'clients_association-modal_associate-label_associate_txt-1': 'Associate:',
  'clients_association-modal_associate-label_associate_txt-2': 'the association is created and the data from the own sales point is kept.',
  'clients_association-modal_associate-label_associate-update_txt-1': 'Associate and update:',
  'clients_association-modal_associate-label_associate-update_txt-2': 'the association is created and the data from the sales point to be associated is copied.',
  'clients_association-modal_update-label_associate_txt-1': 'Update:',
  'clients_association-modal_update-label_associate_txt-2': 'the data from the sales point is copied with the own sales point.',
  'clients_association-modal_update-label_associate-update_txt-1': 'Update and associate:',
  'clients_association-modal_update-label_associate-update_txt-2': 'the association is created and the data from the sales point to be associated is copied.',
  'clients_pending-association-modal_title': 'Pending Associations',
  'clients_pending-association-modal_no-more': 'Do not show again',
  'clients_pending-association-modal_close': 'Close',
  'clients_association-modal_on-ok': 'Accept',
  'clients_association-modal_on-finish': 'Finish',
  'clients_association-modal_on-next': 'Next',
  'clients_association-modal_on-cancel': 'Cancel',
  'clients_association-modal_ps_pdv-code_en': 'PDV Code',
  'clients_association-modal_ps_associate_en': 'Associate',
  'clients_association-modal_ps_update_en': 'Update',
  'clients_association-modal_ps_empty-ps_en': 'No new sales points',
  'clients_association-table_item_client-code': 'Client Code',
  'clients_association-table_item_cif': 'CIF Number',
  'clients_association-table_item_trade-name': 'Trade Name',
  'clients_association-table_item_business-name': 'Business Name',
  'clients_association-table_item_address': 'Address',
  'clients_association-table_item_postal-code': 'Postal Code',
  'clients_association-table_item_city': 'City',
  'clients_association-table_item_province': 'Province',
  'clients_association-table_item_country': 'Country',
  'clients_association-table_item_contact_en': 'Contact',
  'clients_association-table_item_email': 'Email',
  'clients_association-table_item_phone-number': 'Phone Number',
  'clients_association-steps_step-1': 'General Information',
  'clients_association-steps_step-2': 'Sales Points',
  // Add client form
  'clients_add-client-form-label_trade-name': 'Brand Name',
  'clients_add-client-form-label_business-name': 'Company Name',
  'clients_add-client-form-label_client-code': 'Client code',
  'clients_add-client-form-label_clientCode': 'Client code',
  'clients_add-client-form-label_country': 'Country',
  'clients_add-client-form-label_population': 'City',
  'clients_add-client-form-label_province': 'Province',
  'clients_add-client-form-label_address': 'Address',
  'clients_add-client-form-label_postal-code': 'Postal Code',
  'clients_add-client-form-label_cif': 'VAT (Tax Identification)',
  'clients_add-client-form-label_commercial-agents': 'Commercial agents',
  'clients_add-client-form-label_commercial-agents_placeholder': 'Select commercial agents',
  'clients_add-client-form-label_phone-number': 'Phone Number',
  'clients_add-client-form-label_email': 'Email',
  'clients_add-client-form-input-validation_trade-name': 'Please enter the brand name',
  'clients_add-client-form-input-validation_business-name': 'Please enter the company name',
  'clients_add-client-form-input-validation_country': 'Please enter the country',
  'clients_add-client-form-input-validation_population': 'Please enter the city',
  'clients_add-client-form-input-validation_address': 'Please enter the address',
  'clients_add-client-form-input-validation_postal-code': 'Please enter the postal code',
  'clients_add-client-form-input-validation_cif': 'Please enter the VAT (Tax Identification)',
  'clients_add-client-form-input-validation_email-required': 'Please enter the email',
  'clients_add-client-form-input-validation_email': 'Invalid email',
  'clients_add-client-form-input-validation_phone-number': 'Please enter the phone number',
  // Add client
  'clients_add-client_add-manually': 'Add client manually',
  'clients_add-client_add-by-csv-1': 'Upload CSV',
  'clients_add-client_add-by-csv-2': 'clients',
  'clients_add-client_add-by-excel': 'Download Excel template',
  // Client menu
  'clients_menu-desktop_resume': 'Summary',
  'clients_menu-desktop_main-contacts': 'Contacts',
  'clients_menu-desktop_sale-points': 'Stores',
  'clients_menu-desktop_brands-sold': 'Sold brands',
  // Client resume
  'client_resume_title': 'Available Catalog',
  'client_resume_main-info-panel_title': 'General Information',
  'client_resume_main-info-panel_li-info_client-code': 'Client Code:',
  'client_resume_main-info-panel_li-info_trade-name': 'Brand Name:',
  'client_resume_main-info-panel_li-info_legal-name': 'Company name:',
  'client_resume_main-info-panel_li-info_cif': 'Tax ID:',
  'client_resume_main-info-panel_li-info_tarif': 'Rate code:',
  'client_resume_address-info_address__title': 'Postal address',
  'client_resume_address-info_address': 'Address',
  'client_resume_address-info_postal_code': 'Postal code',
  'client_resume_address-info_city': 'City',
  'client_resume_address-info_province': 'Province',
  'client_resume_address-info_country': 'Country',
  'client_resume_social-media-info_title': 'Social media',
  'client_resume_main-info-panel_li-info_web-page': 'Website:',
  'client_resume_main-info-panel_li-info_points-of-sale': 'Points of Sale:',
  'client_resume_main-info-panel_li-info_email': 'Email:',
  'client_resume_main-info-panel_li-info_category': 'Category:',
  'client_resume_main-info-panel_li-info_start-date': 'Registration Date',
  'client_resume_main-info-panel_li-info_start-season': 'Starting Season:',
  'client_resume_main-info-panel_li-info_phone-number': 'Phone:',
  'client_resume_main-info-panel_li-info_main-contact': 'Main Contact:',
  'client_resume_main-info-panel_li-info_contact-email': 'Contact Email:',
  'client_resume_main-info_item-key_name': 'Trade name',
  'client_resume_main-info_item-key_legal_name': 'Company name',
  'client_resume_main-info_item-key_cif': 'Tax ID',
  'client_resume_main-info_item-key_address': 'Address',
  'client_resume_main-info_item-key_postal_code': 'Postal code',
  'client_resume_main-info_item-key_city': 'City',
  'client_resume_main-info_item-key_country_id': 'Country',
  'client_resume_main-info_item-key_province': 'Province',
  'client_resume_main-info_item-key_email': 'Email',
  'client_resume_main-info_item-key_contact_name': 'Primary contact',
  'client_resume_main-info_item-key_tel_prefix': 'Prefix',
  'client_resume_main-info_item-key_tel_sufix': 'Suffix',
  'client_resume_main-info_item-key_web': 'Website',
  'client_resume_main-info_item-key_floor': 'Floor',
  'client_resume_main-info_item-key_door': 'Door',
  'client_resume_main-info_upgrade_new-value': 'New',
  'client_resume_main-info_upgrade_new-actual': 'Current',
  'client_resume_main-info_upgrade_popover_update': 'Update',
  'client_resume_main-info_upgrade_client-updates': 'has changed',
  'client_resume_main-info_edit-button': 'Edit',
  'client_resume_main-info_upgrade_all-popover_title': 'Update new data',
  'client_resume_main-info_upgrade_popover_update-all': 'Update all',
  //////////////////////////

  // CLIENT ///////////////
  // Resume page
  'client_resume-page_history': 'History',
  'client_resume-page_accept-association': 'Associate',
  'client_resume-page_reject-association': 'Reject',
  'client_resume-page_accept-association_btn-title': 'Accept Association',
  'client_resume-page_reject-association_btn-title': 'Reject Association',
  'client-page_history-points-of-sale_associated': 'Associated',
  'client-page_history-points-of-sale_not-associated': 'Not Associated',
  'client-page_history-active-contacts_name': 'Name',
  'client-page_history-active-contacts_email': 'Email',
  'client-page_history-active-contacts_phone-number': 'Phone Number',
  'client-page_history-active-contacts_department': 'Department',
  // Client brands sold
  'client_brands-sold_title': 'Brands Worked With',
  'client_brands-sold_brands_no-results': 'No results found...',
  'client_brands-sold_brands_no-brands-sold': 'No brands sold yet...',
  // Client contacts page
  'client_contacts-page_contacts-title': 'Client contacts',
  'client_contacts-page_agents-title': 'Client sales agents',
  // Sale points page
  'client_sale-points-page_title': 'Stores',
  'client_sale-points-page_add-sale-point': '+ Add',
  'client_sale-points-page_associate-sale-point': 'Associate point of sale',
  'client_sale-points-page_table_client-code': 'Code',
  'client_sale-points-page_table_address': 'Address',
  'client_sale-points-page_table_city': 'City',
  'client_sale-points-page_table_division': 'Division',
  'client_sale-points-page_table_personae': 'Personae',
  'client_sale-points-page_table_tier': 'Tier',
  'client_sale-points-page_table_pdv': 'Store Photos',
  'client_sale-points-page_table_name': 'Name',
  'client_sale-points-page_table_area': 'Commercial area (M2)',
  'client_sale-points-page_table_category': 'Category',
  'client_sale-points-page_table_brands': 'Brands',
  'client_sale-points-page_table_brands-tooltip': 'Brands in the store',
  'client_sale-points-page_table_pos-currency': 'Currency',
  'client_sale-points-page_table_pos-last-exchange-rate': 'Exchange rate',
  'client_sale-points-page_table_disassociate-modal_title_en': 'Unlink Sales Point',
  'client_sale-points-page_table_disassociate-modal_on-ok_en': 'Unlink',
  'client_sale-points-page_table_disassociate-modal_on-cancel_en': 'Cancel',
  'client_sale-points-page_table_disassociate-modal_content_en': 'Are you sure you want to unlink this sales point?',
  'client_sale-points-page_table_associate-modal_title_en': 'Link Sales Points',
  'client_sale-points-page_table_associate-modal_on-ok_en': 'Update',
  'client_sale-points-page_table_associate-modal_on-cancel_en': 'Cancel',
  'client_sale-points-page_table_status_associated': 'Associated',
  'client_sale-points-page_table_status_matching': 'Pending',
  'points-of-sale_drawer_exchange_label': 'Currency',
  'points-of-sale_drawer_add-edit-sale-point_exchange_input-validation': 'Please, enter the currency type',
  'client_sale-points-page_table_status_not-associated': 'Not Associated',
  'client_sale-points-page_upgrade_online': 'Physical store',
  'client_sale-points-page_upgrade_category_id': 'Category',
  'client_sale-points-page_upgrade_name': 'Store name',
  'client_sale-points-page_upgrade_exchange_id': 'Currency type',
  'client_sale-points-page_upgrade_area': 'Commercial area',
  'client_sale-points-page_upgrade_address': 'Address',
  'client_sale-points-page_upgrade_floor': 'Floor',
  'client_sale-ppoints-page_upgrade_door': 'Door',
  'client_sale-points-page_upgrade_city': 'City',
  'client_sale-points-page_upgrade_province': 'Province',
  'client_sale-points-page_upgrade_postal_code': 'Postal code',
  'client_sale-points-page_upgrade_country_id': 'Country',
  'client_sale-points-page_upgrade_lat': 'Latitude',
  'client_sale-points-page_upgrade_lng': 'Longitude',
  'client_sale-points-page_upgrade_tel_prefix': 'Telephone prefix',
  'client_sale-points-page_upgrade_tel_sufix': 'Phone number',
  'client_sale-points-page_upgrade_web': 'Web',
  'client_sale-points-page_upgrade_popconfirm-title': 'Update sales point data',
  'client_sale-points-page_upgrade_popconfirm-description': 'Are you sure you want to update the data of all sales points?',
  'client_sale-points-page_upgrade_upgrade-btn': 'Update sales points',
  'client_business-info_upgrade_all-popover_title': 'Update point of sale data',
  'client_business-info_upgrade_popover_update-all': 'Update all',
  // Point of sale info modal
  'points-of-sale_point-of-sale-info_close-btn': 'Close',
  // Info
  'points-of-sale_point-of-sale-info_info_title': 'Information',
  'points-of-sale_point-of-sale-info_info_code': 'Code',
  'points-of-sale_point-of-sale-info_info_store-type': 'Store Type',
  'points-of-sale_point-of-sale-info_info_store-type_online': 'Online',
  'points-of-sale_point-of-sale-info_info_store-type_physic': 'Physical',
  'points-of-sale_point-of-sale-info_info_category': 'Category',
  'points-of-sale_point-of-sale-info_info_web': 'Web Page',
  'points-of-sale_point-of-sale-info_info_exchange-type': 'Currency Type',
  'points-of-sale_point-of-sale-info_info_start-season': 'Start Season',
  'points-of-sale_point-of-sale-info_info_division': 'Division',
  'points-of-sale_point-of-sale-info_info_segmentation': 'Personae',
  'points-of-sale_point-of-sale-info_info_tier': 'Tier',
  // Connection
  'points-of-sale_point-of-sale-info_connection_title': 'Connection',
  'points-of-sale_point-of-sale-info_connection_no-associated': 'No association with point of sale',
  'points-of-sale_point-of-sale-info_connection_meta-connection': 'Meta Connection',
  'points-of-sale_point-of-sale-info_connection_meta-connection_true': 'Connected',
  'points-of-sale_point-of-sale-info_connection_meta-connection_false': 'Not Connected',
  'points-of-sale_point-of-sale-info_connection_meta-receiving': 'Receiving data from Meta',
  'points-of-sale_point-of-sale-info_connection_meta-receiving_true': 'hrs without receiving data',
  'points-of-sale_point-of-sale-info_connection_meta-receiving_false': 'Not receiving data',
  'points-of-sale_point-of-sale-info_connection_data-share': 'Client shares data',
  'points-of-sale_point-of-sale-info_connection_data-share_true': 'Sharing',
  'points-of-sale_point-of-sale-info_connection_data-share_false': 'Not sharing',
  // Contact
  'points-of-sale_point-of-sale-info_contact_title': 'Contact',
  'points-of-sale_point-of-sale-info_contact_contact-name': 'Contact Person',
  'points-of-sale_point-of-sale-info_contact_phone-number': 'Contact Phone',
  'points-of-sale_point-of-sale-info_contact_email': 'Email',
  'points-of-sale_point-of-sale-info_contact_address': 'Address',
  // Brand works
  'points-of-sale_point-of-sale-info_contact_brand-works_title_0': 'brands at',
  'points-of-sale_point-of-sale-info_contact_brand-works_title_1': 'brand at',
  'points-of-sale_point-of-sale-info_contact_brand-works_empty': 'No brands at the point of sale yet',
  // Drawers
  // Sale points
  'client_drawer_add-edit-sale-point_title': 'Point of sale data',
  'client_drawer_add-edit-sale-point_name': 'Nombre',
  'client_drawer_add-edit-sale-point_point-of-sale-type_en': 'Type of Sales Point',
  'client_drawer_add-edit-sale-point_point-of-sale-type_physical_en': 'Physical Store',
  'client_drawer_add-edit-sale-point_point-of-sale-type_online_en': 'Online Store',
  'client_drawer_add-edit-sale-point_category_en': 'Category',
  'client_drawer_add-edit-sale-point_client-code': 'Code',
  'client_drawer_add-edit-sale-point_client-area': 'Commercial area (M2)',
  'points-of-sale_drawer_own-point-of-sale_input': 'Own store',
  'client_drawer_add-edit-sale-point_address': 'Address',
  'client_drawer_add-edit-sale-point_postal-code': 'Postal Code',
  'client_drawer_add-edit-sale-point_city': 'City',
  'client_drawer_add-edit-sale-point_country': 'Country / Region',
  'client_drawer_add-edit-sale-point_province': 'State / Province',
  'client_drawer_add-edit-sale-point_name_input-validation': 'Por favor, introduce el nombre del punto de venta',
  'client_drawer_add-edit-sale-point_category_input-validation_en': 'Please enter the sales point category',
  'client_drawer_add-edit-sale-point_client-code_input-validation': 'Please enter the client code',
  'client_drawer_add-edit-sale-point_address_input-validation': 'Please enter the address',
  'client_drawer_add-edit-sale-point_postal-code_input-validation': 'Please enter the postal code',
  'client_drawer_add-edit-sale-point_city_input-validation': 'Please enter the city',
  'client_drawer_add-edit-sale-point_country_input-validation': 'Please enter the Country / Region',
  'client_drawer_add-edit-sale-point_province_input-validation': 'Please enter the State / Province',
  'client_drawer_add-edit-sale-point_division': 'Division',
  'client_drawer_add-edit-sale-point_personae': 'Personae',
  'client_drawer_add-edit-sale-point_tier': 'Tier',
  'client_drawer_add-edit-sale-point_share-sale-point-title': 'stores Clasification',
  'client_drawer_add-edit-sale-point_share-sale-point-data': 'Do you want to share data with this store?',
  'client_drawer_add-edit-sale-point_share-sale-point-data-true': 'Yes',
  'client_drawer_add-edit-sale-point_share-sale-point-data-false': 'No',
  'client_drawer_add-edit-sale-point_exchange-rates_title': 'Currency and exchange rates',
  'client_drawer_add-edit-sale-point_exchange-rates_start-date': 'Start date',
  'client_drawer_add-edit-sale-point_exchange-rates_start-date_required': 'Please enter the start date',
  'client_drawer_add-edit-sale-point_exchange-rates_end-date': 'End date',
  'client_drawer_add-edit-sale-point_exchange-rates_rate': 'Exchange rate',
  'client_drawer_add-edit-sale-point_exchange-rates_rate_required': 'Please enter the exchange rate',
  'client_drawer_add-edit-sale-point_exchange-rates_add-new-rate-btn': 'Add exchange rate',
  'client_drawer_add-edit-sale-point_exchange-rates_add-new-rate_warning': 'Please enter an end date for the last exchange rate before adding a new one.',
  'client_drawer_add-edit-sale-point_exchange-rates_save-modal_title': 'Save changes',
  'client_drawer_add-edit-sale-point_exchange-rates_save-modal_content': 'Are you sure you want to save the changes?',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate-since': 'Exchange rate since',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate-to': 'to',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_button': 'History',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_title': 'Exchange rate history',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_date': 'Date:',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_user': 'User:',
  'client_drawer_add-edit-sale-point_exchange-rates_form-item_exchange-rate_popover_rate': 'Exchange rate:',
  'client_drawer_add-edit-sale-point_exchange-rates_accept-button_title':'Accept changes',
  'client_drawer_add-edit-sale-point_exchange-rates_reject-button_title':'Reject changes',
  'client_drawer_add-edit-sale-point_exchange-rates_pos-currency-tooltip':'Point of sale currency',
  'client_drawer_add-edit-sale-point_exchange-rates_company-currency-tooltip':'Company currency',
  // Edit client
  'client_drawer_edit-client_title': 'Company Data',
  // Assign client agents
  'client_drawer_assign-client-commercial-agents_title': 'Assign commercial agents',
  'client_drawer_assign-client-commercial-agents_create-btn': 'Create new',
  //////////////////////////

  // META ///////////////////////////
  'meta_connections_title': 'Connections',
  'meta_connections_new-connection': '+ New',
  'meta_connections_modal_title': 'New connection',
  'meta_connections_modal_title_edit': 'Edit connection',
  'meta_connections_modal_form_user-name': 'Username',
  'meta_connections_modal_form_user-name_required': 'Please enter the username',
  'meta_connections_modal_form_password': 'Password',
  'meta_connections_modal_form_password_required': 'Please enter the password',
  'meta_connections_modal_form_period': 'Frequency',
  'meta_table_createdAt': 'Creation date',
  'meta_table_user-name': 'User',
  'meta_table_password': 'Password',
  'meta_table_type': 'Type',
  'meta_table_period': 'Frequency of submission',
  'meta_connections_configuration-btn': 'Configuration',
  'meta_connections_configuration-btn_maps': 'Maps',
  'meta_connections_configuration-btn_fields': 'Instructions',
  'meta_connections_configuration-btn_shopify': 'Shopify',
  'meta_connections_shopify-configuration_copy': 'Copy',
  'meta_connections_shopify-configuration_query-templates': 'Hub4Retail query templates',
  'meta_connections_shopify-configuration_query-templates_table_title': 'My query templates',
  'meta_connections_shopify-configuration_query-templates_table_tag': 'Tag',
  'meta_connections_shopify-configuration_query-templates_table_queries': 'Queries',
  'meta_connections_shopify-configuration_query-templates_table_popconfirn-delete_title': 'Are you sure you want to delete this template?',
  'meta_connections_shopify-configuration_query-templates_table_popconfirn-delete_description': 'This action cannot be undone',
  'meta_connections_shopify-configuration_query-templates-form_title-create': 'New Query',
  'meta_connections_shopify-configuration_query-templates-form_title-update': 'Edit Query:',
  'meta_connections_shopify-configuration_query-templates-form_template-name': 'Template name',
  'meta_connections_shopify-configuration_query-templates-form_template-name_required': 'Template name is required',
  'meta_connections_shopify-configuration_query-templates-form_queries': 'Queries',
  'meta_connections_shopify-configuration_query-templates-form_queries_required': 'Queries are required',
  'meta_connections_shopify-configuration_query-templates-form_queries_placeholder': 'Select the queries',
  'meta_connections_shopify-configuration_my-queries_title': 'My queries',
  'meta_connections_shopify-configuration_my-queries_table_created-at': 'Creation date',
  'meta_connections_shopify-configuration_my-queries_table_tag': 'Tag',
  'meta_connections_shopify-configuration_my-queries_table_description': 'Description',
  'meta_connections_shopify-configuration_my-queries_table_graphql-query': 'GraphQL query',
  'meta_connections_shopify-configuration_my-queries_table_delete-popconfirm_title': 'Are you sure you want to delete this Query?',
  'meta_connections_shopify-configuration_my-queries_table_delete-popconfirm_description': 'This action cannot be undone',
  'meta_connections_shopify-configuration_query-form_title': 'Edit query:',
  'meta_connections_shopify-configuration_query-form_query-name': 'Query name',
  'meta_connections_shopify-configuration_query-form_query-name_required': 'Query name is required',
  'meta_connections_shopify-configuration_query-form_description': 'Description',
  'meta_connections_shopify-configuration_query-form_description_required': 'Description is required',
  'meta_connections_shopify-configuration_query-form_graphql-query': 'GraphQL query',
  'meta_connections_shopify-configuration_query-form_graphql-query_required': 'Query is required',
  'meta_connections_shopify-configuration_test-query_data-msg-1': 'You need to add the query',
  'meta_connections_shopify-configuration_test-query_data-msg-2': 'from Shop to the connector of',
  'meta_connections_shopify-configuration_test-query_data-msg-3': 'No connection with the connector',
  'meta_connections_shopify-configuration_test-query_data-msg-4': 'No connection with Shopify',
  'meta_connections_shopify-configuration_test-query_title': 'Test query',
  'meta_connections_shopify-configuration_test-query_btn-success': 'Save and test',
  'meta_connections_shopify-configuration_edit-api-connection_title': 'Connector settings for',
  'meta_connections_shopify-configuration_edit-api-connection_get-sample': 'Get sample',
  'meta_connections_shopify-configuration_edit-api-connection_empty-sample': 'No queries available for this connector.',
  'meta_connections_shopify-configuration_edit-api-connection_go-to-api-configuration': 'Go to API configuration of',
  'meta_connections_shopify-configuration_edit-api-connection_go-to-configuration': 'Go to configuration',
  'meta_connections_shopify-configuration_edit-api-connection_select-queries': 'Select the queries you want to run on the connector of',
  'meta_connections_shopify-configuration_field-table-list_title': 'Map instructions',
  'meta_connections_shopify-configuration_field-table-list_delete-fields': 'Delete instructions',
  'meta_connections_shopify-configuration_field-table-list_import-fields': 'Import instructions',
  'meta_connections_shopify-configuration_field-table-list_add-field': 'Add instruction',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_select-form': 'Select the form type',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_select-field-type': 'Select the instruction type:',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_title': 'Remove instruction from map',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_onOk': 'Remove from map',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_description-1': 'Are you sure you want to remove the instruction',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_delete-map-field-modal_description-2': 'from the map?',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_title': 'Import instructions',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_btn_import': 'Import',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_my-queries-templates': 'My instruction templates',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_emprty-templates': 'No instruction templates',
  'meta_connections_shopify-configuration_field-table-list_handle-field-form_import-map-fields_modal_go-to-fields': 'Go to instructions',
  'meta_connections_shopify-configuration_test-map_title': 'Test map',
  'meta_connections_shopify-configuration_test-map_form_audience': 'Audience',
  'meta_connections_shopify-configuration_test-map_form_audience-placeholder': 'Select an audience',
  'meta_connections_shopify-configuration_test-map_form_query': 'Select a query to test mapping',
  'meta_connections_shopify-configuration_test-map_form_query-response': 'Or copy the code you want to map',
  'meta_connections_shopify-configuration_test-map_form_clean': 'Clean',
  'meta_connections_shopify-configuration_test-map_form_test': 'Test',
  'meta_connections_shopify-configuration_test-map_empty-results': 'No results',
  'meta_connections_shopify-configuration_test-map_info': 'Info:',
  'meta_connections_shopify-configuration_test-map_errors': 'Errors:',
  'meta_connections_shopify-configuration_test-map_result': 'Resulting data:',
  'meta_connections_shopify-configuration_maps_title': 'My maps',
  'meta_connections_shopify-configuration_maps_create-map-btn': 'Create map',
  'meta_connections_shopify-configuration_maps_name': 'Name',
  'meta_connections_shopify-configuration_maps_description': 'Description',
  'meta_connections_shopify-configuration_maps_audience': 'Audience type',
  'meta_connections_shopify-configuration_maps_fields': 'No. of instructions',
  'meta_connections_shopify-configuration_maps_created-at': 'Creation date',
  'meta_connections_shopify-configuration_maps_delete_title': 'Are you sure you want to delete this map?',
  'meta_connections_shopify-configuration_maps_create-map_modal_title': 'Create map',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_tag': 'Map name',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_description': 'Map description',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_item-required': 'This field is required',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_audience': 'Audience',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_audience-placeholder': 'Select an audience',
  'meta_connections_shopify-configuration_maps_create-map_modal_form_submit-btn': 'Create map',
  'meta_connections_map-fields-configuration_title': 'Instruction settings',
  'meta_connections_map-fields-configuration_copy-fields-template': 'Copy',
  'meta_connections_map-fields-configuration_h4r-fields-templates_title': 'Hub4Retail instruction templates',
  'meta_connections_map-fields-configuration_my-fields-templates_title': 'My instruction templates',
  'meta_connections_map-fields-configuration_my-fields-templates_empty-templates': 'No instruction templates',
  'meta_connections_map-fields-configuration_my-fields-templates_popconfirn-delete-title': 'Are you sure you want to delete this instruction template?',
  'meta_connections_map-fields-configuration_my-fields_title': 'My instructions',
  'meta_connections_map-fields-configuration_my-fields_delete-selection': 'Delete selection',
  'meta_connections_map-fields-configuration_my-fields_delete-popconfirm-title': 'Are you sure you want to delete this instruction?',
  'meta_table_connection-name': 'Connection name',
  'meta_table_last-update': 'Last upload',
  'meta_table_last-connection': 'Last connection',
  'meta_table_status': 'Status',
  'meta_connections_modal_popover-title': 'Connection info',
  'meta_connections_edit-info_title': 'Edit connection info',
  'meta_connections_edit-configuration_title': 'Edit connection configuration',
  'meta_connections_edit-map_title': 'Edit map info',
  'meta_connections_edit-map_form_tag': 'Map name',
  'meta_connections_edit-map_form_description': 'Map description',
  'meta_connections_edit-map_form_required': 'This field is required',
  'meta_connections_edit-map_form_audience': 'Audience',
  'meta_connections_edit-map_form_audience-placeholder': 'Select an audience',
  'meta_connections_edit-map_form_submit': 'Update',
  'meta_connections_edit-info_btn-tooltip': 'Edit connection',
  'meta_connections_remove-popover_title': 'Remove connection with Shopify',
  'meta_connections_remove-popover_description': 'Are you sure you want to remove the connection with Shopify?',
  'meta_connections_edit-connection-mapping_title': 'Manage data maps to process',
  'meta_connections_edit-connection-mapping_select': 'Select the map type:',
  'meta_connections_edit-connection-mapping_select_catalog': 'Catalog',
  'meta_connections_edit-connection-mapping_select_sale': 'Sales',
  'meta_connections_modal_form_shopify_domain': 'Domain',
  'meta_connections_modal_form_shopify_domain-required': 'Shopify domain is required',
  'meta_connections_modal_form_shopify_access-token': 'Access token',
  'meta_connections_modal_form_shopify_access-token-required': 'Shopify access token is required',
  'meta_connections_modal_form_shopify_access-api-secret-key': 'API secret key',
  'meta_connections_modal_form_shopify_access-api-secret-key-required': 'Shopify API secret key is required',
  'meta_connections_modal_form_shopify_steps_create-connection_title': 'Create connection',
  'meta_connections_modal_form_shopify_steps_set-connection_title': 'Set connection',
  'meta_connections_modal_form_shopify_go-to-connections': 'Back to connections',
  'meta_connections_modal_form_shopify_alert-success': 'Shopify API connection established.',
  'meta_connections_modal_form_shopify_alert-error': 'No connection with Shopify API, please check the details and save the connection again.',
  'meta_connections_modal_form_prestashop_store-url': 'Store URL',
  'meta_connections_modal_form_prestashop_store-url-required': 'Shopify store URL is required',
  'meta_connections_modal_form_prestashop_version': 'Prestashop version',
  'meta_connections_modal_form_prestashop_version-required': 'Prestashop version is required',
  'meta_connections_modal_form_odoo_instance-url': 'Instance URL',
  'meta_connections_modal_form_odoo_instance-url-required': 'Odoo instance URL is required',
  'meta_connections_modal_form_odoo_user-name': 'Username',
  'meta_connections_modal_form_odoo_user-name-required': 'Odoo username is required',
  'meta_connections_modal_form_odoo_database-name': 'Database name',
  'meta_connections_modal_form_odoo_database-name-required': 'Odoo database name is required',
  'meta_connections_api-connections_comming-soon': 'Coming soon...',
  'meta_connections_create-new-connection_connection-type': 'Connection type:',
  'meta_connections_form-items_tag-form-item_label': 'Connection name',
  'meta_connections_form-items_tag-form-item_label-required': 'Please enter a name',
  'meta_connections_modal_form_access-api-key': 'API key',
  'meta_connections_modal_form_access-api-key-required': 'Shopify API key is required',
  'meta-connections_mapping-form_periodicity': 'Periodicity',
  'meta-connections_mapping-form_periodicity_required': 'Periodicity is required',
  'meta-connections_mapping-form_periodicity_dairy': 'Daily',
  'meta-connections_mapping-form_periodicity_weekly': 'Weekly',
  'meta-connections_mapping-form_periodicity_biweekly': 'Biweekly',
  'meta-connections_mapping-form_periodicity_monthly': 'Monthly',
  'meta-connections_modal_input_btn-reset-form': 'Reset',
  'meta-connections_mapping-table_column-3_label': 'Resulting data',
  'meta-connections_mapping-table_column-2_label': 'CSV columns',
  'meta-connections_mapping-table_column-2_select-label': 'Select a column',
  'meta-connections_mapping-table_column-2_select-label-multiple': 'Select one or more columns',
  'meta-connections_mapping-table_column-2_select-format_label': 'Select a format',
  'meta-connections_delete-popconfirm_icon-tooltip': 'Delete connection',
  'meta_table_status_success': 'Active',
  'meta_table_status_error': 'Error',
  'meta_connections_shopify.configuration-form_items_template-label': 'Templates',
  'meta_connections_shopify.configuration-form_items_template-label-placeholder': 'Select one or more templates',
  'meta_connections_shopify.configuration-form_items_queries-label': 'Queries',
  'meta_connections_shopify.configuration-form_items_queries-check-all': 'Check all',
  ///////////////////////////////

  // ACTIONS ////////////////
  // Clients
  'clients_actions_add-client-success': 'Client created successfully',
  'clients_actions_update-client-success': 'Client updated successfully',
  'clients_actions_update-client-error': 'Error updating client',
  'clients_actions_client-exists': 'Client already exists',
  'clients_actions_add-point-of-sale-success': 'Sale point created successfully',
  'clients_actions_add-point-of-sale-error': 'Error creating sale point',
  'clients_actions_update-point-of-sale-success': 'Sale point updated successfully',
  'clients_actions_upgrade-point-of-sale-success': 'Point of sale updated successfully',
  'clients_actions_upgrade-points-of-sale-success': 'Points of sale updated successfully',
  'clients_actions_update-point-of-sale-error': 'Error updating sale point',
  'action_points-of-sale_assign-point-of-sale-categories_error': 'Error updating point of sale categories',
  'clients_actions_remove-point-of-sale-success': 'Point of sale successfully removed',
  'clients_actions_remove-point-of-sale-error': 'Error removing the point of sale',
  'clients_actions_share-data-point-of-sale-success': 'Sharing data with sale point',
  'clients_actions_dont-share-data-point-of-sale-success': 'You have stopped sharing data with sale point',
  'clients_actions_association-success': 'Client successfully associated',
  'clients_actions_association-error': 'Error in associating the client',
  'clients_actions_reject-association-success': 'Successfully unlinked',
  'clients_actions_reject-association-error': 'Error in unlinking the client',
  'clients_actions_accept-ps-association-success': 'Sales point successfully linked',
  'clients_actions_accept-ps-association-error': 'Error in linking the sales point',
  'clients_actions_update-exchange-rate-error': 'Error updating the exchange rate',
  'clients_actions_update-exchange-rate-success': 'Exchange rate updated successfully',
  'clients_actions_update-exchange-rate-error-403': 'To add exchange rates, the company currency must be added first',
  'clients_actions_update-exchange-rate-error-404': 'The point of sale does not exist',
  // Commercial Profile
  'commercial-profile_actions_init-bio_error': 'Error fetching bio',
  'commercial-profile_actions_update-bio_success': 'Bio updated successfully',
  'commercial-profile_actions_update-bio_error': 'Error updating bio',
  // Catalog Correlation
  'catalog-correlation_assign-generics_success': 'Generics assigned successfully',
  'catalog-correlation_assign-generics_error': 'Error assigning generics',
  // Catalog CSV upload
  'catalog-csv-upload_publish-upload-success-1': 'Catalog published successfully',
  'catalog-csv-upload_publish-upload-success-2': 'Catalog hidden successfully',
  'catalog-csv-upload_publish-upload-error-1': 'Error publishing the catalog',
  'catalog-csv-upload_publish-upload-error-2': 'Error hiding the catalog',
  'catalog-csv-upload_reject-upload-success': ' The catalog is being deleted; it will be reflected on the platform in a few minutes.',
  'catalog-csv-upload_reject-upload-error': 'Error deleting the catalog',
  'catalog-csv-upload_set-start-season-date-success': 'Start season date updated successfully',
  'catalog-csv-upload_set-start-season-date-error': 'Error updating the start season date',
  'catalog-csv-upload_set-end-season-date-success': 'End season date updated successfully',
  'catalog-csv-upload_set-end-season-date-error': 'Error updating the end season date',
  'catalog-csv-upload_enable-season-success-1': 'Season enabled successfully',
  'catalog-csv-upload_enable-season-success-2': 'Season disabled successfully',
  'catalog-csv-upload_enable-season-error-1': 'Error enabling the season',
  'catalog-csv-upload_enable-season-error-2': 'Error disabling the season',
  'catalog-csv-upload_get-mappings-error-1': 'Error fetching mapping keys',
  'catalog-csv-upload_get-mappings-error-2': 'Server error fetching mapping keys',
  'catalog-csv-upload_delete-mapping-success': 'Mapping deleted successfully',
  'catalog-csv-upload_delete-mapping-error': 'Error deleting the mapping',
  'catalog-csv-upload_create-mapping-success': 'Mapping created successfully',
  'catalog-csv-upload_create-mapping-error': 'Error creating the mapping',
  // Commercial profile
  'commercial-proile_actions_set-banner-action-success': 'Banner updated successfully',
  'commercial-proile_actions_set-banner-action-error': 'Error updating the banner',
  'commercial-proile_actions_set-banner-action-server-error': 'Server error updating the banner',
  'commercial-proile_actions_set-products-action-success': 'Products updated successfully',
  'commercial-proile_actions_set-products-action-error': 'Error updating the products',
  'commercial-proile_actions_set-products-action-server-error': 'Server error updating the products',
  'commercial-proile_actions_remove-product-action-error': 'Error deleting the product',
  'commercial-proile_actions_remove-product-action-server-error': 'Server error deleting the product',
  'commercial-proile_actions_set-videos-action-success': 'Videos updated successfully',
  'commercial-proile_actions_set-videos-action-error': 'Error updating the videos',
  'commercial-proile_actions_set-videos-action-server-error': 'Server error updating the videos',
  'commercial-proile_actions_remove-video-action-error': 'Error deleting the video',
  'commercial-proile_actions_remove-video-action-server-error': 'Server error deleting the video',
  // Commercial agents
  'actions_commercial-agents_get-commercial-agents_error': 'Error retrieving commercial agents',
  'actions_commercial-agents_create-commercial-agent_success': 'Commercial agent successfully created',
  'actions_commercial-agents_create-commercial-agent_error': 'Error creating commercial agent',
  'actions_commercial-agents_assign-commercial-agent_error': 'Error assigning client to commercial agent',
  'actions_commercial-agents_unassign-commercial-agent_error': 'Error unassigning client from commercial agent',
  'actions_commercial-agents_update-commercial-agent_success': 'Commercial agent successfully updated',
  'actions_commercial-agents_update-commercial-agent_error': 'Error updating commercial agent',
  'actions_commercial-agents_delete-commercial-agent_success': 'Commercial agent successfully deleted',
  'actions_commercial-agents_delete-commercial-agent_error': 'Error deleting commercial agent',
  // Main contacts
  'actions_main-contacts_get-main-contacts_error': 'Error fetching main contacts',
  'actions_main-contacts_create-main-contact_success': 'Contact successfully created',
  'actions_main-contacts_create-main-contact_error': 'Error creating contact',
  'actions_main-contacts_update-main-contact_success': 'Contact successfully updated',
  'actions_main-contacts_update-main-contact_error': 'Error updating contact',
  'actions_main-contacts_delete-main-contact_success': 'Contact successfully deleted',
  'actions_main-contacts_delete-main-contact_error': 'Error deleting contact',
  // Brand users
  'actions_brand-users_get-brand-users_error': 'Error retrieving users',
  'actions_brand-users_create-brand-user_success': 'User created successfully',
  'actions_brand-users_create-brand-user_exists': 'User already exists',
  'actions_brand-users_create-brand-user_error': 'Error creating user',
  'actions_brand-users_update-brand-user_success': 'User updated successfully',
  'actions_brand-users_update-brand-user_error': 'Error updating user',
  'actions_brand-users_update-brand-user_rol-error': 'Error updating user role',
  'actions_brand-users_update-brand-user_notifications-error': 'Error updating notification types',
  'actions_brand-users_delete-brand-user_success': 'User deleted successfully',
  'actions_brand-users_delete-brand-user_error': 'Error deleting user',
  // Sales matching
  'sales-matching_match-sale_success': 'Sale successfully matched',
  'sales-matching_match-sale_error': 'Could not match the sale',
  'sales-matching_match-sale_premission-error': 'You do not have permission to match sales',
  'sales-matching_match-sale_client-product-id-not-found-error': 'Client product ID not found',
  // Catalog tarifs
  'actions_catalog-tarifs_create-tarif_success': 'Rate created successfully',
  'actions_catalog-tarifs_create-tarif_error': 'Error creating the rate',
  'actions_catalog-tarifs_update-tarif_success': 'Rate updated successfully',
  'actions_catalog-tarifs_update-tarif_error': 'Error updating the rate',
  'actions_catalog-tarifs_delete-tarif_success': 'Rate deleted successfully',
  'actions_catalog-tarifs_delete-tarif_error': 'Error deleting the rate',
  'actions_catalog-tarifs_download-tarif_success': 'Rate downloaded successfully',
  'actions_catalog-tarifs_download-tarif_error': 'Error downloading the rate',
  'actions_catalog-tarifs_download-tarif_warning': 'There are no products to download',
  'actions_catalog-tarifs_get-tarif_error': 'Error retrieving the rates',
  ///////////////////////////

  // SETTINGS PAGE ////////
  'settings-page_nav_chronos': 'Chronos',
  'settings-page_nav_devices': 'Devices',
  'settings-page_nav_touch-screen': 'Touch Screens',
  'settings-page_nav_users': 'Users',
  'settings-page_nav_system-settings': 'System Settings',
  'settings-page_nav_commercial-profile': 'Commercial Profile Brand',
  'settings-page_nav_billing': 'Billing',
  'settings-page_nav_support': 'Support',
  // Users page
  'settings-page_users-page_create-user-btn': 'Create User',
  // Meta
  'action_meta_get-connections_error': 'Error retrieving connections',
  'action_meta_delete-connection_success': 'Connection successfully deleted',
  'action_meta_delete-connection_error': 'Error deleting the connection',
  'action_meta_create-connection_success': 'Connection successfully created',
  'action_meta_get-queries_error': 'Error retrieving queries',
  'action_meta_create-sftp-connection_error-403': 'Username already exists. Try another one.',
  'action_meta_get-mapping-keys_error': 'Error retrieving mapping keys',
  'action_meta_create-shopify-connection_error-409': 'Domain already in use',
  'action_meta_create-shopify-connection_error': 'Error creating the connection',
  'action_meta_update-connection_success': 'Connection successfully updated',
  'action_meta_update-connection_error': 'Error updating the connection',
  'action_meta_create-connection_error': 'Error creating the connection',
  'settings-page_nav_meta': 'Meta',
  /////////////////////////

  // COMMERCIAL PROFILE ////////////
  'commercial-profile_title': 'Commercial Profile',
  'commercial-profile_btn-edit': 'Edit',
  'commercial-profile_btn-save': 'Save',
  'commercial-profile_banner_title': 'Upload Banner',
  'commercial-profile_banner_p-1': 'The banner will appear on the commercial profile of your brand to promote it and connect with multi-brand stores.',
  'commercial-profile_banner_p-2': 'Upload a banner of 1800x200 px.',
  'commercial-profile_banner_p-3': 'Ensure it is of good quality and appealing to attract multi-brand stores.',
  'commercial-profile_about-us_title': 'About Us',
  'commercial-profile_about-us_p-1': 'Tell a little about your brand to attract multi-brand stores. Up to a maximum of 100 words.',
  'commercial-profile_about-us_p-2': 'The description will appear on the commercial profile of your brand to promote it and connect with multi-brand stores.',
  'commercial-profile_our-products_title': 'Our Products',
  'commercial-profile_our-products_p': 'Select 5-10 products from your latest season.',
  'commercial-profile_our-videos_title': 'Some of our videos...',
  'commercial-profile_our-videos_p': 'Select 4 products from your latest season.',
  'commercial-profile_banner_modal_title': 'Select Banner',
  'commercial-profile_modal_onOk': 'Accept',
  'commercial-profile_modal_onCancel': 'Cancel',
  'commercial-profile_banner-title': 'Select a banner for your commercial profile',
  'commercial-profile_modal-content_banners-empty-msg': 'There are no banners yet.',
  'commercial-profile_modal-content_navigate-banners-btn': 'Go to multimedia banners',
  'commercial-profile_modal-content_videos-empty-msg': 'There are no videos yet.',
  'commercial-profile_modal-content_navigate-videos-btn': 'Go to media videos',
  'commercial-profile_our-products_modal_title': 'Select products',
  'commercial-profile_our-products_modal_max-items-msg': 'You can only select 10 products.',
  'commercial-profile_our-products_modal_see-more-btn': 'See more',
  'commercial-profile_our-videos_modal_title': 'Select videos',
  'commercial-profile_our-videos_modal_max-items-msg': 'You can only select 4 videos.',
  'commercial-profile_search-input-placeholder_en': 'Search by name or code',
  //////////////////////////////////

  // SALES MATCHING ///////////////////////////////////////////////
  'sales-matching_columns_search-on': 'Search in',
  'sales-matching_columns_operator_contains': 'Contains',
  'sales-matching_columns_operator_ends-with': 'Ends with',
  'sales-matching_columns_operator_starts-with': 'Starts with',
  'sales-matching_columns_operator_equals': 'Equals',
  'sales-matching_columns_operator_not-equals': 'Not equals',
  'sales-matching_columns_operator_in': 'With',
  'sales-matching_columns_operator_not-in': 'Without',
  'sales-matching_columns_operator_greater-than': 'Greater than',
  'sales-matching_columns_operator_less-than': 'Less than',
  'sales-matching_columns_operator_is-null': 'Is empty',
  'sales-matching_columns_operator_is-not-null': 'Is not empty',
  'sales-matching_columns_column-search_search': 'Search',
  'sales-matching_columns_column-search_reset': 'Reset',
  'sales-matching_columns_column-search_close': 'Close',
  'sales-matching_confirm-match': 'Are you sure you want to save the changes?',
  /////////////////////////////////////////////////////////////////

  // CATALOG TARIFS /////////////////////////////
  'catalog-tarifs_list_add-tarif': 'Add rate',
  'catalog-tarifs_list_upload-tarif_csv-allowed': 'Only CSV files are allowed',
  'catalog-tarifs_list_upload-tarif_error': 'Error reading the file',
  'catalog-tarifs_list_upload-modal-title': 'Upload rates',
  'catalog-tarifs_list_upload-modal_download-csv': 'Download CSV of all products',
  'catalog-tarifs_list_upload-modal_download-pending-products-csv': 'Download CSV of products without price',
  'catalog-tarifs_list_upload-modal_upload-csv': 'Upload CSV',
  'catalog-tarifs_list_create-modal_create-title': 'Create new rate',
  'catalog-tarifs_list_create-modal_update-title': 'Edit rate',
  'catalog-tarifs_list_create-modal_form_code-label': 'Rate code',
  'catalog-tarifs_list_create-modal_form_code_required': 'Rate code is required',
  'catalog-tarifs_list_create-modal_form_description-label': 'Rate description',
  'catalog-tarifs_list_create-modal_form_description_required': 'Rate description is required',
  'catalog-tarifs_list_create-modal_form_clients-label': 'Clients',
  'catalog-tarifs_table_code': 'Rate code',
  'catalog-tarifs_table_description': 'Rate description',
  'catalog-tarifs_table_currency': 'Currency',
  'catalog-tarifs_table_clients': 'Clients',
  'catalog-tarifs_table_products-with-tarifs': 'Products with rate',
  'catalog-tarifs_table_products-without-tarifs': 'Products without rate',
  'catalog-tarifs_table_actions_upload-tarifs': 'Upload rates',
  'catalog-tarifs_table_actions_edit-tarif-tooltip': 'Edit rate',
  'catalog-tarifs_table_actions_see-tarif-tooltip': 'View rate',
  'catalog-tarifs_table_actions_delete-tarif-tooltip': 'Delete rate',
  'catalog-tarifs_table_actions_delete-tarif-popconfirm': 'Are you sure you want to delete this rate?',
  'catalog-tarifs_table_actions_see-tarif-title': 'View rates for',
  'catalog-tarifs_table_see-tarif_product-description': 'Product description',
  'catalog-tarifs_table_see-tarif_ean': 'EAN',
  'catalog-tarifs_table_see-tarif_reference': 'Reference',
  'catalog-tarifs_table_see-tarif_color-description': 'Color description',
  'catalog-tarifs_table_see-tarif_color-code': 'Color code',
  'catalog-tarifs_table_see-tarif_size': 'Size',
  'catalog-tarifs_table_see-tarif_pvi': 'RRP',
  'catalog-tarifs_table_see-tarif_pvpr': 'MSRP',
  'catalog-tarifs_reload-tarifs': 'Reload',
  'catalog-tarifs_history_table_title': 'Upload history',
  'catalog-tarifs_history_table_createdAt': 'Upload date',
  'catalog-tarifs_history_table_insert': 'Inserted',
  'catalog-tarifs_history_table_update': 'Updated',
  'catalog-tarifs_history_table_not_found': 'Not found',
  'catalog-tarifs_history_table_eans_not_found': 'Download EANs not found',
  'catalog-tarifs_history_table_with_no_tarif': 'Products without rate',
  'catalog-tarifs_history_table_error': 'Error',
  'catalog-tarifs_history_table_tarif_file-confirmed': 'File confirmed',
  'catalog-tarifs_history_table_tarif_file-processed': 'File processed',
  'catalog-tarifs_history_table_tarif_file-error': 'File error',
  ///////////////////////////////////////////////

  // NOTIFICATIONS /////////////////
  // Notifications Page
  'notifications-page_notifications-title': 'Notifications',
  'notifications-page_alerts-title': 'Alerts',
  'notifications_btn-name_catalog': 'View Catalog',
  'notifications_btn-name_profile': 'View Profile',
  'notifications_list_show-all': 'All',
  'notifications_list_show-unreaded': 'Unread',
  'notifications_list_per-page-select': 'per page',
  // Popover
  'notifications_popover_title': 'NOTIFICATIONS',
  'notifications_popover_empty-notifications': 'No notifications',
  'notifications_popover_btn-name_catalog': 'View Catalog',
  'notifications_popover_btn-name_profile': 'View Profile',
  'notifications_popover_item_mark-as-readed_msg': 'Marked as read',
  'notifications_popover_item_mark-as-unreaded_msg': 'Marked as unread',
  'notifications_popover_item_mark-as-readed': 'Mark as read',
  'notifications_popover_item_mark-as-unreaded': 'Mark as unread',
  'notifications_popover_all-notifications-btn': 'All notifications',
  'notifications_popover_accept': 'Accept',
  'notifications_popover_reject': 'Reject',
  'notifications_popover_pending_en': 'Pending',
  'alerts_popover_title': 'ALERTS',
  'alerts_popover_empty-notifications': 'No alerts',
  'alerts_popover_all-notifications-btn': 'All alerts',
  ///////////////////////////////////

  // WHOLESALE FEED /////////////////
  'wholesale-feed_info_title': 'General Information',
  'wholesale-feed_info_city': 'City',
  'wholesale-feed_info_province': 'Province',
  'wholesale-feed_main-contact_title': 'Main Contact',
  'wholesale-feed_main-contact_name': 'Name',
  'wholesale-feed_main-contact_email': 'Email',
  'wholesale-feed_main-contact_phone-number': 'Phone Number',
  'wholesale-feed_main-contact_sector': 'Sector',
  'wholesale-feed_points-of-sale_title': 'Points of Sale',
  'wholesale-feed_working-brands_title': 'Brands Worked With',
  ///////////////////////////////////

  // MESSAGE PAGES //////////
  // Error
  'errors-page_404_subtitle': 'Sorry, the page you are looking for does not exist.',
  'errors-page_404_btn-go-back': 'Go back',
  // Coming soon
  'coming-soon-page_title': 'Coming Soon!',
  'coming-soon-page_go-back': 'Go Back',
  ///////////////////////////

  // BREADCRUMBS ///////////////
  'breadcrumbs_multimedia': 'Multimedia',
  'breadcrumbs_multimedia-videos': 'Videos',
  'breadcrumbs_multimedia-images': 'Images',
  'catalog_breadcrumb_item1': 'Catalogue',
  'catalog_breadcrumb_item2': 'See catalogue',
  'breadcrumbs_multimedia-banners': 'Banners',
  'catalog-uploads_breadcrumb': 'Catalog Uploads',
  'catalog-uploads_handle-images_breadcrumb': 'Image management',
  'breadcrumb_catalog-download': 'Download catalog',
  'breadcrumb_catalog-update-references': 'Update references',
  'catalog-uploads-preview_breadcrumb': 'Preview',
  'add-catalog_breadcrumb': 'Add Catalog',
  'catalog_correlation': 'Reference correlation',
  'catalog_generic': 'Generic H4R',
  'breadcrumb_catalog_tarifs': 'Rates',
  // Clients
  'breadcrumbs_clients': 'Clients',
  'breadcrumbs_clients-list': 'Clients list',
  'breadcrumbs_add-client': 'Add client',
  'breadcrumbs_resume': 'Summary',
  'breadcrumbs_main-contacts': 'Contacts',
  'breadcrumbs_sale-points': 'Stores',
  'breadcrumbs_brands-sold': 'Sold brands',
  // Account
  'breadcrumbs_account': 'Account',
  'breadcrumbs_account_profile': 'Profile',
  'breadcrumbs_account_company': 'Company Information',
  'breadcrumbs_account_contacts': 'Contacts',
  'breadcrumbs_account_commercial-agents': 'Commercial Agents',
  // Settings
  'breadcrumbs_settings': 'Settings',
  'breadcrumbs_commercial-profile': 'Commercial Profile',
  // Meta
  'breadcrumbs_meta_edit_connetion': 'Edit connection',
  'breadcrumbs_meta_map_list': 'Maps',
  'breadcrumbs_meta_edit_map': 'Edit map',
  'breadcrumbs_meta_fields-configuration': 'Instruction settings',
  // Sales
  'breadcrumbs_sales': 'Sales',
  //////////////////////////////

  // MODALS ////////////////////
  'modal_email-verified_title': 'Check your email',
  'modal_email-verified_content': 'To proceed with the process, please check your email',
  'modal_email-verified_content-1': 'Verify the address from the received email link and then click',
  'modal_email-verified_content_btn_resend': 'Resend Verification',
  'modal_email-verified_content_btn_reload': 'Reload',
  'modal_email-verified_content_notif_resend_title_success': 'Verification email resent successfully.',
  'modal_email-verified_content_notif_resend_title_error': 'An error occurred while resending the verification email.',
  'modal_email-verified_content_notif_resend_title': 'Resend Notification',
  'modal_email-verified_content_notif_resend_content-1': 'The verification email has been sent to this address',
  'modal_email-verified_content_notif_resend_content-2': 'Check your email to continue.',
  //////////////////////////////

  // POLICY PRIVACY //////////
  'policy-privacy-modal_title': 'Terms of Service',
  'policy-privacy-modal_btn-accept': 'Accept',
  'policy-privacy-modal_btn-cancel': 'Cancel',
  'policy-privacy-modal_checkbox': 'I accept the Terms of Service',
  'policy-privacy-modal_checkbox-message': 'Accept the privacy policy and terms.',
  ////////////////////////////

  // SERVER DOWN MODAL /////
  'server-down-modal_title': 'Server Error',
  'server-down-modal_content': 'We are experiencing issues with our services. Please try again later or contact technical support.',
  //////////////////////////

  // CHANGE DEFAULT PASSWORD MODAL /////////////////
  'change-default-password-modal_title': 'Change the password to continue',
  'change-default-password_error-1': 'Error changing the password',
  'change-default-password_error-2': 'Error updating the user',
  'change-default-password_error-3': 'Server error',
  //////////////////////////////////////////////////

  // NOTIFICATIONS /////////
  'notification-error_message': 'Error Code',
  'notification-error_description': 'Please try again later. If the problem persists, contact Hub4Retail and provide the error code.',
  //////////////////////////

  // NOTIFICATIONS TYPES /////////
  'notifications_type_catalog_wh-upload-sales-reminder': 'Reminder to upload multi-brand sales',
  'notifications_type_catalog_wh-first-upload-sales-reminder': 'First sales upload',
  'notifications_type_catalog_br-accepts-request': 'Brand accepted association request',
  'notifications_type_catalog_file-error': 'File error',
  'notifications_type_catalog_file-success': 'File processed',
  'notifications_type_catalog_wh-point-of-sale-associated': 'Point of sale associated',
  'notifications_type_catalog_wh-request-association': 'Client requests association',
  'notifications_type_catalog_wh-pos-map-reminder': 'Point of sale mapping reminder',
  ////////////////////////////////

  // GOOGLE ADDRESS FORM //////
  'google-address-form_address': 'Address',
  'google-address-form_floor': 'Floor',
  'google-address-form_door': 'Door',
  'google-address-form_postal-code': 'Postal Code',
  'google-address-form_city': 'City',
  'google-address-form_province': 'Province',
  'google-address-form_country': 'Country',
  'google-address-form_select-country': 'Select a country',
  /////////////////////////////

  // CSV MAPPING FIELDS //////
  'csv-mapping-feld__product_description': 'Product description',
  'csv-mapping-feld__reference': 'Reference',
  'csv-mapping-feld__color': 'Color',
  'csv-mapping-feld__season': 'Season',
  'csv-mapping-feld__ean': 'EAN',
  'csv-mapping-feld__gender': 'Gender',
  'csv-mapping-feld__material': 'Composition',
  'csv-mapping-feld__segmentation': 'Segmentation',
  'csv-mapping-feld__family': 'Family',
  'csv-mapping-feld__division': 'Division',
  'csv-mapping-feld__tier': 'Catalog Segmentation (Tier)',
  'csv-mapping-feld__color_description': 'Color Description',
  'csv-mapping-feld__pvi': 'WHP (Wholesale Price)',
  'csv-mapping-feld__pvpr': 'SRP (Suggested Retail Price)',
  'csv-mapping-feld__size': 'Size',
  'csv-mapping-feld__tags': 'Labels',
  /////////////////////////////

  // LANGUAGES /////////////////
  'spanish-lang': 'Spanish',
  'english-lang': 'English',
  'french-lang': 'French',
  'italian-lang': 'Italian',
  ////////////////////////////

  // SHARED //////////////////
  'settings': 'Settings',
  'logout': 'Logout',
  'admin-panel_link': 'Admin Panel',
  'see-more': 'See more',
  'see-less': 'See less',
  'see-all': 'See all',
  'btn-save': 'Save',
  'edit-btn-label': 'Edit',
  'delete-btn-label': 'Delete',
  'btn-cancel': 'Cancel',
  'see-more-content-button': 'See more',
  'never-label': 'Never',
  'clean-form': 'Clear form',
  'reset-btn': 'Reset',
  'reset-next': 'Next',
  'btn-next': 'Next',
  'send-btn': 'Send',
  'not-authorized-warning': 'You do not have permission to perform this action',
  'form-label_role': 'Role',
  'form-label_language': 'Language',
  ////////////////////////////
};

export default englishTranslation;
